<template>
  <div>
    <app-bars></app-bars>
    <v-main>
      <router-view></router-view>

    </v-main>

    <app-footer></app-footer>

  </div>
</template>

<script>
import Footer from "../shared/Footer";
import AppBars from "../shared/AppBars";

export default {
  name: "ManagerArea",
  components: {

    'appFooter': Footer,
    'appBars': AppBars,
  }
}
</script>

<style scoped>

</style>